(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coming-later-dynamic"] && !Shopify.designMode) return;
  try {
    
  /* ---------- COUNTDOWN + "Notify Me" reveal ---------- */
  (function(){
    function pad(n){ return n<10 ? '0'+n : n }
    document.querySelectorAll('.banner-countdown').forEach(function(el){
      var dateStr = el.dataset.releaseDate
      if(!dateStr) return
      var launch = new Date(dateStr).getTime()
      var valSpans = {
        d: el.querySelector('.countdown-days'),
        h: el.querySelector('.countdown-hours'),
        m: el.querySelector('.countdown-minutes'),
        s: el.querySelector('.countdown-seconds')
      }
      function tick(){
        var now = Date.now(), diff = launch - now
        if(diff <= 0){ el.style.display='none'; return }
        var d = Math.floor(diff/864e5)
        var h = Math.floor(diff/36e5) % 24
        var m = Math.floor(diff/6e4)  % 60
        var s = Math.floor(diff/1e3)  % 60
        valSpans.d.textContent = pad(d)
        valSpans.h.textContent = pad(h)
        valSpans.m.textContent = pad(m)
        valSpans.s.textContent = pad(s)
      }
      tick(); setInterval(tick, 1000)
    })

    /* Toggle reminder form */
    document.querySelectorAll('.coming-later-button').forEach(function(btn){
      btn.addEventListener('click',function(){
        var form = this.parentElement.querySelector('.reminder-form')
        if(form) form.style.display = form.style.display === 'block' ? 'none' : 'block'
      })
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coming-later"] && !Shopify.designMode) return;
  try {
    
  /* ---------- COUNTDOWN + "Notify Me" reveal ---------- */
  (function(){
    function pad(n){ return n<10 ? '0'+n : n }
    document.querySelectorAll('.banner-countdown').forEach(function(el){
      var dateStr = el.dataset.releaseDate
      if(!dateStr) return
      var launch = new Date(dateStr).getTime()
      var valSpans = {
        d: el.querySelector('.countdown-days'),
        h: el.querySelector('.countdown-hours'),
        m: el.querySelector('.countdown-minutes'),
        s: el.querySelector('.countdown-seconds')
      }
      function tick(){
        var now = Date.now(), diff = launch - now
        if(diff <= 0){ el.style.display='none'; return }
        var d = Math.floor(diff/864e5)
        var h = Math.floor(diff/36e5) % 24
        var m = Math.floor(diff/6e4)  % 60
        var s = Math.floor(diff/1e3)  % 60
        valSpans.d.textContent = pad(d)
        valSpans.h.textContent = pad(h)
        valSpans.m.textContent = pad(m)
        valSpans.s.textContent = pad(s)
      }
      tick(); setInterval(tick, 1000)
    })

    /* Toggle reminder form */
    document.querySelectorAll('.coming-later-button').forEach(function(btn){
      btn.addEventListener('click',function(){
        var form = this.parentElement.querySelector('.reminder-form')
        if(form) form.style.display = form.style.display === 'block' ? 'none' : 'block'
      })
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upcoming-drops"] && !Shopify.designMode) return;
  try {
    
  /* ---------- COUNTDOWN + "Notify Me" reveal ---------- */
  (function(){
    function pad(n){ return n<10 ? '0'+n : n }
    document.querySelectorAll('.banner-countdown').forEach(function(el){
      var dateStr = el.dataset.releaseDate
      if(!dateStr) return
      var launch = new Date(dateStr).getTime()
      var valSpans = {
        d: el.querySelector('.countdown-days'),
        h: el.querySelector('.countdown-hours'),
        m: el.querySelector('.countdown-minutes'),
        s: el.querySelector('.countdown-seconds')
      }
      function tick(){
        var now = Date.now(), diff = launch - now
        if(diff <= 0){ el.style.display='none'; return }
        var d = Math.floor(diff/864e5)
        var h = Math.floor(diff/36e5) % 24
        var m = Math.floor(diff/6e4)  % 60
        var s = Math.floor(diff/1e3)  % 60
        valSpans.d.textContent = pad(d)
        valSpans.h.textContent = pad(h)
        valSpans.m.textContent = pad(m)
        valSpans.s.textContent = pad(s)
      }
      tick(); setInterval(tick, 1000)
    })

    /* Toggle reminder form */
    document.querySelectorAll('.coming-soon-button').forEach(function(btn){
      btn.addEventListener('click',function(){
        var form = this.parentElement.querySelector('.reminder-form')
        if(form) form.style.display = form.style.display === 'block' ? 'none' : 'block'
      })
    })
  })()

  } catch(e) { console.error(e); }
})();
})();
